module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskEdit1-ed333fcf1612f3859416eec91e2e8221.jpg";